export const BANK_UPGRADE_COST = {
  level1: 0,
  level2: 40000,
  level3: 80000,
  level4: 160000,
  level5: 320000,
  level6: 640000,
  level7: 1280000,
  level8: 2560000,
  level9: 5120000,
  level10: 10240000,
};

export const BANK_UPGRADE_REWARD = {
  level1: 0.5,
  level2: 0.7,
  level3: 1,
  level4: 1.5,
  level5: 1.8,
  level6: 2.2,
  level7: 3,
  level8: 3.5,
  level9: 4,
  level10: 6,
};

/** USDT bank withdraw daily cap = 2× the bank's level reward. Mirrors backend `BANK_USDT_WITHDRAW_LIMIT_MULTIPLIER`. */
export const BANK_USDT_WITHDRAW_LIMIT_MULTIPLIER = 2

/**
 * Rolling-24h USDT withdraw cap in USDT, by bank level: 1, 1.4, 2, 3, 3.6, 4.4, 6, 7, 8, 12.
 * Derived from {@link BANK_UPGRADE_REWARD}; mirrors backend `BANK_USDT_WITHDRAW_DAILY_LIMIT`.
 *
 * The server does not enforce this yet — `usdtWithdraw` is still a stub that rejects every
 * request — so this gate is advisory UI only and must not be treated as a security control.
 */
export const BANK_USDT_WITHDRAW_DAILY_LIMIT: Record<string, number> = Object.fromEntries(
  Object.entries(BANK_UPGRADE_REWARD).map(([level, reward]) => [
    level,
    Math.round(reward * BANK_USDT_WITHDRAW_LIMIT_MULTIPLIER * 100) / 100,
  ]),
)

/** Daily USDT withdraw cap for a bank level; falls back to level 1 for unknown levels. */
export function usdtWithdrawDailyLimitForBankLevel(bankLevel: number): number {
  return (
    BANK_USDT_WITHDRAW_DAILY_LIMIT[`level${bankLevel}`] ??
    BANK_USDT_WITHDRAW_DAILY_LIMIT.level1
  )
}

export const BANK_WATER_USAGE = {
  level1: 8,
  level2: 11,
  level3: 14,
  level4: 17,
  level5: 20,
  level6: 23,
  level7: 26,
  level8: 29,
  level9: 32,
  level10: 35,
};

export const BANK_UPGRADE_COOLDOWN = {
  level1: 0,
  level2: 90000, // 25 hours
  level3: 180000, // 50 hours
  level4: 360000, // 100 hours
  level5: 720000, // 200 hours
  level6: 1440000, // 400 hours
  level7: 2880000, // 800 hours
  level8: 5760000, // 1600 hours
  level9: 11520000, // 3200 hours
  level10: 23040000, // 6400 hours
};

export const BANK_UPGRADE_COST_RESOURCES = {
  level1: { iron: 0, wood: 0, stone: 0 },
  level2: { iron: 6210, wood: 62108, stone: 31054 },
  level3: { iron: 14472, wood: 144720, stone: 72360 },
  level4: { iron: 33584, wood: 335846, stone: 167922 },
  level5: { iron: 77220, wood: 772196, stone: 386098 },
  level6: { iron: 175104, wood: 1751040, stone: 875520 },
  level7: { iron: 378220, wood: 3782194, stone: 1891096 },
  level8: { iron: 788934, wood: 7889336, stone: 3944668 },
  level9: { iron: 1608912, wood: 16089114, stone: 8044556 },
  level10: { iron: 3192426, wood: 31924266, stone: 15962132 },
};
